import {skipToken} from '@reduxjs/toolkit/query'
import {useEffect} from 'react'

import useMyId from '../../../hooks/useMyId'
import {getBuildTypeArg} from '../../../rest/buildTypes'
import {restApi} from '../../../services/rest'
import type {BuildTypeId} from '../../../types'
import {subscribeOnUserEvents} from '../../../utils/subscriber'
import * as SubscriptionEvents from '../../../utils/subscriptionEvents'

export function useRefetchBuildTypeOnPermissionsChange(buildTypeId?: BuildTypeId) {
  const myId = useMyId()
  const {refetch} = restApi.endpoints.getBuildTypeNormalized.useQuerySubscription(
    buildTypeId != null ? getBuildTypeArg(buildTypeId) : skipToken,
  )
  useEffect(
    () =>
      buildTypeId != null && myId != null
        ? subscribeOnUserEvents(
            `buildType:${buildTypeId}`,
            myId,
            [SubscriptionEvents.USER_PERMISSIONS_CHANGED],
            refetch,
          )
        : undefined,
    [refetch, myId, buildTypeId],
  )
}
